import React, { Component } from 'react';
import '../Footer/Footer';
import packageJson from '../../../package.json'

class Footer extends Component {
  render() {
    return (
      <footer className="sticky-footer">
        <div className="container my-auto">
          <div className="copyright text-center my-auto no-print">
            <span>Copyright © T3 Next. 2022 v. {packageJson?.version} </span>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;